import React from 'react';
import InstagramGallerySkeleton from 'views/common/components/UI/GridsGallery/InstagramGallery/InstagramGallerySkeleton';
import ToursGallerySkeleton from 'views/common/components/UI/GridsGallery/ToursGallery/ToursGallerySkeleton';

const GridsGallerySkeleton = (props) => {
  const { variant } = props;
  return (
    <>
      {variant == 'tours' && <ToursGallerySkeleton />}
      {variant == 'instagram' && <InstagramGallerySkeleton />}
    </>
  );
};

export default GridsGallerySkeleton;
